import { Navigate, useParams } from "react-router-dom";

/** Old note URLs open the read-only list with that version selected. Notes are not editable. */
export function FirmwareReleaseNoteDetailPage(): JSX.Element {
  const params = useParams<{ id: string }>();
  const noteId = Number.parseInt(params.id ?? "", 10);
  if (!Number.isFinite(noteId) || noteId < 1) {
    return <Navigate to="/engineering/firmware?tab=notes" replace />;
  }
  return <Navigate to={`/engineering/firmware?tab=notes&ids=${String(noteId)}`} replace />;
}
